// store/videoSlice.js
import { createSlice } from '@reduxjs/toolkit';

const videoSlice = createSlice({
  name: 'videos',
  initialState: {
    blobs: {}, 
    blobsAvatars: {}, 
    blobsBefore: {}
  },
  reducers: {
    addVideoBlob: (state, action) => {
      const { id, blob } = action.payload;
      state.blobs[id] = blob;
    },
    addVideoBlobAvatars: (state, action) => {
        const { id, blobUrl } = action.payload;
        state.blobsAvatars[id] = blobUrl;
      },
      addVideoBlobBefore: (state, action) => {
        const { id, blobUrl } = action.payload;
        state.blobsBefore[id] = blobUrl;
      },
  },
});

export const { addVideoBlob, addVideoBlobAvatars, addVideoBlobBefore } = videoSlice.actions;
export default videoSlice.reducer;
